var trim = function(x) {
    return x.toString().replace(/^\s|\s$/g, '');
}
var $ = require('jquery');
var COOKIE_DOMAIN = "vip.xunlei.com";
var CHILD_COOKIE_NAME = 'vipcookie';


if (window.location.href.indexOf('jsq.xunlei.com') != -1) {
    COOKIE_DOMAIN = 'jsq.xunlei.com';
    CHILD_COOKIE_NAME = "jsqcookie";
}

function setCookie(name, value, hours, isBaseDomain) {
    value = value + '';
    if (isBaseDomain != undefined && isBaseDomain == 1) {
        setRealCookie(name, value, hours, 1); //绑定到.xunlei中
    } else {
        var vipcookie = getRealCookie(CHILD_COOKIE_NAME);
        if (trim(value) == '') { //删除cookie
            if (vipcookie != '') {
                var check = getCookie(name);
                if (check != '') {
                    var cookies = vipcookie.split('&');
                    var newcookie = new Array;
                    for (var i = 0; i < cookies.length; i++) {
                        var ary = cookies[i].split('=');
                        if (ary.length > 1 && ary[0] != name) {
                            newcookie.push(cookies[i]);
                        }
                    }
                    vipcookie = newcookie.join('&');
                }
            }
        } else { //添加cookie
            //删除原生cookie中的此值
            setRealCookie(name, '', 0);
            if (vipcookie == '') {
                vipcookie = trim(name) + '=' + encodeURIComponent(value);
            } else {
                //check if has the same item , if so , replace it , otherwise add it.
                var check = getCookie(name);
                if (check != '') {
                    var cookies = vipcookie.split('&');
                    for (var i = 0; i < cookies.length; i++) {
                        var ary = cookies[i].split('=');
                        if (ary.length > 1 && ary[0] == name) {
                            cookies[i] = name + '=' + encodeURIComponent(value);
                            break;
                        }
                    }
                    vipcookie = cookies.join('&');
                } else {
                    vipcookie = vipcookie + '&' + trim(name) + '=' + encodeURIComponent(value);
                }
            }
        }
        if (hours != undefined) {
            setRealCookie(CHILD_COOKIE_NAME, vipcookie, hours);
        } else {
            setRealCookie(CHILD_COOKIE_NAME, vipcookie);
        }
    }
}

function setRealCookie(name, value, hours, isBaseDomain) {
    if (arguments.length > 2) {
        var expireDate = new Date(new Date().getTime() + hours * 3600000);
        if (isBaseDomain != undefined && isBaseDomain == 1) {
            document.cookie = name + "=" + encodeURIComponent(value) + "; path=/; domain=xunlei.com; expires=" + expireDate.toGMTString();
        } else {
            document.cookie = name + "=" + encodeURIComponent(value) + "; path=/; domain=" + COOKIE_DOMAIN + "; expires=" + expireDate.toGMTString();
        }
    } else {
        document.cookie = name + "=" + encodeURIComponent(value) + "; path=/; domain=" + COOKIE_DOMAIN;
    }
}

function getCookie(name) {
    var val = getRealCookie(name);
    if (trim(val) == '') {
        var vipcookie = getRealCookie(CHILD_COOKIE_NAME);
        if (trim(vipcookie) == '') {
            return '';
        }
        var cookies = vipcookie.split('&');
        for (var i = 0; i < cookies.length; i++) {
            var ary = cookies[i].split('=');
            if (ary.length > 1 && ary[0] == name) {
                return decodeURIComponent(ary[1]);
            }
        }
        return '';
    } else {
        return trim(val); //如果cookie中有该值，优先使用该值
    }
}

function getRealCookie(name) {
    return (document.cookie.match(new RegExp("(^" + name + "| " + name + ")=([^;]*)")) == null) ? "" : decodeURIComponent(RegExp.$2);
}

function clearCookie() {
    //清除子域名
    var ckeys = [CHILD_COOKIE_NAME, "vip_nickname", "ci_session", "vip_ci_session", "_x_a_", 'vip-xunlei-com-vipcookie', 'act-vip-xunlei-com-vipcookie'];
    for (var i = 0, len = ckeys.length; i < len; i++) {
        setRealCookie(ckeys[i], "", 0);
    }
    //主域名
    var ckeys1 = ["sessionid", "usrname", "unickname", "nickname", "usernick", "userid", "usertype", "usernewno", "blogresult", "score", "order", "isvip", "sex", "upgrade", "logintype", "checkans", "checkpwd", "jumpkey"];
    for (var i = 0, len = ckeys1.length; i < len; i++) {
        setRealCookie(ckeys1[i], "", 0, 1);
    }
}

window.setCookie = setCookie;
window.setRealCookie = setRealCookie;
window.getCookie = getCookie;
window.getRealCookie = getRealCookie;
window.clearCookie = clearCookie;



//////////////////
// WEBPACK FOOTER
// ./src/common/cookie.js
// module id = 12
// module chunks = 2